// 修改昵称弹窗
import { Modal, Form, Input, message } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import DialogHeading from '@/components/dialogheading';
import './ProfileEditors.scss';
import { useSelector, useDispatch } from 'react-redux';
import { fetchModifyUserInfo, fetchUserInfo } from '@/apis/user';

const EditNicknameModal = ({ nicknameOpen, setNicknameOpen }) => {
  // 配置初始化
  const dispatch = useDispatch();
  const [nicknameForm] = Form.useForm();
  const userInfo = useSelector(state => state.user.userInfo);
  // 用户点击确认后处理请求
  const onNicknameCreate = async (values) => {
    // 关闭弹窗
    setNicknameOpen(false);
    try {
      // 提交修改
      const result = await fetchModifyUserInfo(values, userInfo.username);
      // 修改成功后，重新拉用户信息
      if (result.success) {
        await dispatch(fetchUserInfo());
        message.success('资料修改成功');
      } else {
        message.error(result?.error || '修改失败');
      }
    } catch (err) {
      message.error('修改失败');
    }
  };
  return (
    <Modal
      open={nicknameOpen}
      className="profileEditor-modal"
      centered
      width={480}
      title={<DialogHeading icon={<EditOutlined />} title="修改昵称" description="设置一个方便伙伴认出你的昵称" />}
      okText="保存昵称"
      cancelText="取消"
      okButtonProps={{ autoFocus: true, htmlType: 'submit' }}
      onCancel={() => setNicknameOpen(false)}
      destroyOnHidden
      modalRender={dom => (
        <Form
          layout="vertical"
          form={nicknameForm}
          name="nickname_form_in_modal"
          // 默认为用户原本信息，没有则置空
          initialValues={{ nickname: userInfo.nickname || '' }}
          clearOnDestroy
          onFinish={values => onNicknameCreate(values)}
        >
          {dom}
        </Form>
      )}
    >
      {/* 昵称输入框 */}
      <Form.Item name="nickname" label="昵称" extra="最多 12 个字符。">
        <Input maxLength={12} placeholder="输入你的昵称" showCount />
      </Form.Item>
    </Modal>
  )
}

export default EditNicknameModal;
